// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"5d46487b","164":"e98e8f0f","500":"7f11d567","746":"a2b3fddd","929":"00f1d264","992":"820c1683"}[chunkId] + ".chunk.js";
};